<template>
  <div :style="cssVars">
    <page-layout
      :noSideBar="false"
      :headerBackgroundColor="cssVars['--outcome-primary']"
    >
      <template v-slot:headerContent>
        <div class="row">
          <span
            :style="`color: ${cssVars['--outcome-secondary']}`"
            class="title"
          >
            {{
              currentUserData.sustainabilityBusiness_name
                ? currentUserData.sustainabilityBusiness_name
                : "Test Business"
            }}
          </span>
        </div>
        <div class="row items-center">
          <q-select
            v-model="reportType"
            :options="[
              { label: 'Data Reporting', path: '/data' },
              { label: 'Story Board', path: '/storyBoard' },
            ]"
            filled
            :style="`width: 300px;
                      background-color: rgba(255,255, 255, 0.3);
                      border-radius: 5px;
                      `"
            dense
            dropdown-icon="mdi-chevron-down"
            bg-color="white"
            color="black"
            @input="reportTypeChanged"
          ></q-select>
          <span v-if="reportType" class="headerText text-white q-mx-sm">
            For
          </span>
          <sustainability-dropdown
            v-if="reportType"
            :model="outcome"
            class="q-ml-sm"
            :style="`width: 230px;
                      background-color: ${
                        selectedOutcome &&
                        selectedOutcome.id == $route.params.outcomeID
                          ? cssVars['--outcome-secondary']
                          : 'rgba(0,0, 0, 0.3)'
                      };
                      border-radius: 5px;
                      `"
            :options="outcomesList"
            :isObjects="true"
            objectKey="label"
            :allOption="true"
            @input="selectOutcome"
          ></sustainability-dropdown>
          <span v-if="reportType" class="headerText text-white q-mx-sm">
            In
          </span>
          <year-picker
            ref="yearPicker"
            label=""
            :bg="`${
              selectedOutcome && selectedOutcome.id == $route.params.outcomeID
                ? cssVars['--outcome-secondary']
                : 'rgba(0,0, 0, 0.3)'
            }`"
            @selectYear="selectYear"
          ></year-picker>
        </div>
      </template>
      <template v-slot:content>
        <div class="column q-pa-sm">
          <q-scroll-area
            class="col-auto"
            style="height: calc(100vh - 187px)"
            :thumb-style="{
              background: '#162c479c',
              opacity: 1,
              width: '8px',
              height: '8px',
              borderRadius: '20px',
            }"
          >
            <div class="row wrap">
              <div class="col-12">
                <h3 class="storyBoardHeader q-my-xs">
                  Showcasing {{ storyCards.length }} stories
                </h3>
              </div>
              <div
                class="q-pa-xs"
                v-for="(storyCard, index) in storyCards"
                :key="`storyCards_${index}`"
                @click="selectedStory = storyCard"
              >
                <storyCard
                  :flat="false"
                  :largeVersion="false"
                  :greyBG="true"
                  :data="storyCard"
                />
              </div>
            </div>
          </q-scroll-area>
        </div>
      </template>
      <template v-slot:sideBarContent>
        <div class="column full-height full-width sidebar">
          <div class="col-auto q-py-md q-px-md" style="height: calc(109px)">
            <div class="row full-height items-center">
              <h3 class="header" v-if="selectedStory">Highlighted Story</h3>
              <h3 class="header" v-else>Story Board</h3>
            </div>
          </div>
          <div
            class="col-auto q-px-md"
            style="height: calc(100vh - 226px) !important"
          >
            <q-scroll-area
              style="height: calc(100vh - 206px) !important"
              :thumb-style="{
                background: '#162c479c',
                opacity: 1,
                width: '8px',
                height: '8px',
                borderRadius: '20px',
              }"
            >
              <div v-if="selectedStory">
                <q-img :src="selectedStory.imgUrl
            ? selectedStory.imgUrl
            : 'https://upstreamnz.s3.ap-southeast-2.amazonaws.com/Sustainability+Plans/oatas_default.png'"></q-img>
                <h4 class="q-mt-sm q-mb-none">
                  {{ selectedStory.title }}
                </h4>
                <div class="col-12 q-py-sm" v-if="selectedStory.completed_at">
                  {{ selectedStory.completed_at | momentFormatMonthDayYear }}
                </div>
                <div class="col-12 q-py-sm" v-if="selectedStory.description">
                  {{ selectedStory.description }}
                </div>
              </div>
              <div v-else class="text-accent">
                <p>
                  Please use the filters to show <b>Stories</b> from a specific
                  outcome
                </p>
                <p>Click on a <b>Story</b> to reveal the full context</p>
              </div>
            </q-scroll-area>
          </div>
        </div>
      </template>
    </page-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import YearPicker from "@/components/generalComponents/yearPicker.vue";
import PageLayout from "@/components/pageLayout/pageLayout.vue";
import SustainabilityDropdown from "@/components/sustainabilityDropdown/sustainabilityDropdown.vue";
import storyCardForm from "@/components/storyCards/storyCardForm.vue";
import storyCard from "@/components/storyCards/storyCard.vue";
import { getCSSVars } from "@/functions/cssVars";
export default {
  components: {
    YearPicker,
    PageLayout,
    SustainabilityDropdown,
    storyCardForm,
    storyCard,
  },

  computed: {
    ...mapGetters({
      outcomesList: "outcomes/listIncludeAll",
      outcomeReferenceList: "outcomes/keyReferenceList",
      currentUserData: "auth/currentUserData",
      outcomePlan: "businessOutcomePlans/current",
      outcomePlanLoading: "businessOutcomePlans/currentLoading",
      selectedOutcome: "general/selectedOutcome",
      storyCards: "storyCard/list",
      storyCardsLoading: "storyCard/listLoading",
    }),
    cssVars() {
      let outcome = this.selectedOutcome;
      return getCSSVars(outcome);
    },
  },

  data: () => ({
    outcome: null,
    reportType: "Story Board",
    selectedYear: null,

    newStoryCardLoading: true,

    storyCardDialog: true,
    selectedStory: null,
  }),
  watch: {
    selectedOutcome: function () {
      this.loadData();
    },
    selectedYear: function () {
      this.loadData();
    },
    $route: function () {
      this.handleRoute();
    },
  },
  async mounted() {
    this.handleRoute();
    if (this.selectedOutcome) {
      this.initSelectedOutcome();
    }

    if (!this.$route.params.year && this.$route.params.outcomeID) {
      this.selectYear(this.$moment().format("YYYY"));
    } else {
      this.selectedYear = this.$route.params.year;
    }
    this.loadData();
  },
  methods: {
    getCSSVars: getCSSVars,
    initSelectedOutcome() {
      this.outcome = this.selectedOutcome;
    },
    loadData() {
      this.$store.dispatch("storyCard/loadAll", {
        outcome_id: this.$route.params.outcomeID,
        year: this.selectedYear,
      });
    },
    handleRoute() {
      if (this.$route.params.outcomeID) {
        this.loadOutcome();
        // this.loadDataReport();
      } else {
        this.$store.dispatch("general/updateSelectedOutcome", null);
      }
    },
    async loadOutcome() {
      if (this.outcomesList.length < 1) {
        await this.$store.dispatch("outcomes/loadAll");
      }
      let outcome = this.outcomeReferenceList[this.$route.params.outcomeID];
      this.$store.dispatch("general/updateSelectedOutcome", outcome);
    },
    selectOutcome(outcome) {
      let route;
      if (this.$route.params.outcomeID) {
        let split = this.$route.path.split(
          `/outcome/${this.$route.params.outcomeID}`
        );
        route = `${split[0]}/outcome/${outcome.id}${split[1]}`;
      } else {
        let split = this.$route.path.split(`/outcome`);
        route = route = `${split[0]}/outcome/${outcome.id}`;
      }
      this.$router.push(route);

      setTimeout(() => {
        if (!this.$route.params.year) {
          this.selectYear(this.$moment().format("YYYY/"));
        }
      }, 100);
    },
    selectYear(val) {
      this.selectedYear = val.split("/")[0];
      let route;
      if (this.$route.params.year) {
        let split = this.$route.path.split(`/year/${this.$route.params.year}`);
        route = `${split[0]}/year/${this.selectedYear}${split[1]}`;
      } else {
        let split = this.$route.path.split(`/year`);
        route = route = `${split[0]}/year/${this.selectedYear}`;
      }

      this.$router.push(route);
    },
    reportTypeChanged(val) {
      let route = this.$route.path.split("/storyBoard");
      this.$router.push(`${route[0]}${val.path}${route[1]}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.storyBoardHeader {
  font-size: 1.5rem;
  font-weight: 800;
  color: $accent;
}

.sidebar {
  .header {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 1.3rem;
    line-height: 29px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    color: $accent2;
    margin: 10px 0px;
  }
  h4 {
    font-size: 1rem;
    font-weight: 600;
    color: $accent;
    line-height: 1.1rem;
  }
}
</style>
